"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isMatchWith2 = _interopRequireDefault(require("lodash/isMatchWith"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PropTypesUtils = require("../../../utils/PropTypesUtils");

var _Divider = _interopRequireDefault(require("../Divider/Divider"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _MenuItem = _interopRequireDefault(require("./MenuItem"));

var _MenuGroup = _interopRequireDefault(require("./MenuGroup"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['appearance', 'theme'];
/**
 * The Menu component is intended for navigational use.
 *
 * - Inherits all properties from the StackingLayout component.
 * - The Menu only officially supports one tier of `collapsible` or `submenu`
 *   type MenuGroups.
 *
 * @keywords Menu, Navigation, Sidebar
 */

var Menu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu() {
    var _this;

    _classCallCheck(this, Menu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this));

    _this.assignMenuManagement = function (props) {
      var children = props.children,
          activeKeyPath = props.activeKeyPath,
          openKeyMap = props.openKeyMap,
          onClickCallback = props.onClickCallback;
      return _react.default.Children.map(children, function (child, i) {
        var childWithProps; // MenuItem clone and reassignment

        if ((0, _PropTypesUtils.areComponentsEqual)(child, _MenuItem.default)) {
          var isActive = _this.isActive(activeKeyPath, child);

          childWithProps = _react.default.cloneElement(child, {
            onClick: onClickCallback,
            active: isActive,
            assignedKey: child.key
          }); // MenuGroup clone and reassignment
        } else if ((0, _PropTypesUtils.areComponentsEqual)(child, _MenuGroup.default)) {
          var _isActive = _this.isActive(activeKeyPath, child);

          var assignedKeyMap = _this.assignOpenKeyMap(openKeyMap, child);

          childWithProps = _react.default.cloneElement(child, {
            onClick: onClickCallback,
            expanded: !(0, _isEmpty2.default)(assignedKeyMap),
            assignedKey: child.key,
            activeKeyPath: _this.assignActiveKeyPath(activeKeyPath, _isActive),
            openKeyMap: assignedKeyMap,
            assignMenuManagement: _this.assignMenuManagement
          }); // Otherwise pass through
        } else {
          childWithProps = child;
        }

        return childWithProps;
      });
    };

    _this.handleMenuChange = _this.handleMenuChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Handler for menu change
   * @param {object} info - menu info
   * See props onClick for further details.
   */


  _createClass(Menu, [{
    key: "handleMenuChange",
    value: function handleMenuChange(info) {
      var event = info.event,
          key = info.key,
          keyPath = info.keyPath,
          item = info.item,
          type = info.type;
      var openKeyMap = this.props.openKeyMap; // Update Open Key Paths if collapsible menu was toggled

      var newOpenKeyMap;
      var newKeyPath;

      if (openKeyMap && info.type === 'collapsible-header') {
        newOpenKeyMap = this.mapOpenKeys(openKeyMap, info.keyPath);
        newKeyPath = this.props.activeKeyPath; // Otherwise assign new key path
      } else {
        newOpenKeyMap = openKeyMap;
        newKeyPath = keyPath;
      }

      var newInfo = {
        event: event,
        key: key,
        keyPath: newKeyPath,
        openKeyMap: newOpenKeyMap,
        item: item,
        type: type
      };

      if ((0, _isFunction2.default)(this.props.onClick)) {
        this.props.onClick(newInfo);
      }
    }
    /**
     * Map open keys that are for collapsible MenuGroups
     * @param {array} openKeyMap - Multidimensional array
     * @param {array} newPath - new open key path
     * @returns {array} map of open keys
     */

  }, {
    key: "mapOpenKeys",
    value: function mapOpenKeys(openKeyMap, newPath) {
      var _this2 = this;

      var newMap = (0, _filter2.default)(openKeyMap, function (currentPath) {
        return !_this2.isPathOpen(currentPath, newPath);
      }); // Compare newPath to existing paths. Then logic to decide if we are adding
      // or removing a path from the openKeyMap.

      var newKeyPath; // Add new path

      if (openKeyMap.length === newMap.length) {
        newKeyPath = [].concat(_toConsumableArray(openKeyMap), [newPath]); // Remove matching path
      } else {
        newKeyPath = newMap;
      }

      return newKeyPath;
    }
    /**
     * Check if current path is existing
     * @param {array} currentPath - key path
     * @param {array} newPath - key path
     * @returns {boolean} true if path is open
     */

  }, {
    key: "isPathOpen",
    value: function isPathOpen(currentPath, newPath) {
      var customizer = function customizer(currentValue, srcValue) {
        return currentValue === srcValue;
      };

      var match = (0, _isMatchWith2.default)(currentPath, newPath, customizer);
      return match;
    }
    /**
     * Check if child item is active
     * @param {array} keyPath - path of keys
     * @param {object} child - react node
     * @returns {boolean} true if child key matches current key path key
     */

  }, {
    key: "isActive",
    value: function isActive(keyPath, child) {
      return keyPath && keyPath[0] === child.key;
    }
    /**
     * Returns reduced keyPath to next child item that is active
     * @param {array} activeKeyPath - path of active keys
     * @param {boolean} isActive - is child active
     * @returns {array/null} last key path with current key match removed or null
     */

  }, {
    key: "assignActiveKeyPath",
    value: function assignActiveKeyPath(activeKeyPath, isActive) {
      return isActive ? activeKeyPath.slice(1) : null;
    }
    /**
     * Filters out only matching open key paths
     * @param {array} openKeyMap - map of open keys
     * @param {object} child - react node
     * @returns {array} verified key map
     */

  }, {
    key: "verifiedOpenKeyMap",
    value: function verifiedOpenKeyMap(openKeyMap, child) {
      var _this3 = this;

      return (0, _filter2.default)(openKeyMap, function (keyPath) {
        return _this3.isActive(keyPath, child);
      });
    }
    /**
     * Assigns remainder open key paths to descendant
     * @param {array} openKeyMap - open key paths
     * @param {object} child - react node
     * @returns {array} assigned open key map
     */

  }, {
    key: "assignOpenKeyMap",
    value: function assignOpenKeyMap(openKeyMap, child) {
      var _this4 = this;

      var verifiedMap = this.verifiedOpenKeyMap(openKeyMap, child);
      return (0, _map2.default)(verifiedMap, function (keyPath) {
        return _this4.assignActiveKeyPath(keyPath, _this4.isActive(keyPath, child));
      });
    }
    /**
     * Clones menu manageable children and adds additonal props for
     * menu management handling.
     * @param {object} props - Properties to assign
     * @param {array} props.children - array of react nodes
     * @param {array} props.activeKeyPath - path of active key
     * @param {array} props.openKeyMap - open key paths
     * @param {function} props.onClickCallback - onClick callback
     * @returns {array} children with new props
     */

  }, {
    key: "renderItems",

    /**
     * Goes through each of the menuItems and transforms them to ReactElements
     * Note: {item}s are the equivlent of {children}.
     * @param {object} menuItems - see propsTypes.items
     * @param {object} managementProps - Props for menu to manage
     *   children internally
     * @returns {array} - array of React.elements
     */
    value: function renderItems(menuItems, managementProps) {
      var _this5 = this;

      return menuItems.map(function (item) {
        var name = item.name,
            items = item.items,
            props = _objectWithoutProperties(item, ["name", "items"]);

        var activeKeyPath = managementProps.activeKeyPath,
            openKeyMap = managementProps.openKeyMap,
            onClickCallback = managementProps.onClickCallback;

        switch (name) {
          case Menu.MENU_CHILDREN.DIVIDER:
            return _react.default.createElement(_StackingLayout.default, {
              key: item.key,
              padding: "0px-20px"
            }, _react.default.createElement(_Divider.default, _extends({
              type: "short"
            }, props)));

          case Menu.MENU_CHILDREN.MENU_GROUP:
            var isActive = _this5.isActive(activeKeyPath, item);

            var assignedKeyMap = _this5.assignOpenKeyMap(openKeyMap, item);

            return _react.default.createElement(_MenuGroup.default, _extends({}, props, {
              onClick: onClickCallback,
              expanded: !(0, _isEmpty2.default)(assignedKeyMap),
              assignedKey: item.key,
              activeKeyPath: _this5.assignActiveKeyPath(activeKeyPath, isActive),
              openKeyMap: assignedKeyMap,
              assignMenuManagement: _this5.assignMenuManagement
            }), _this5.renderItems(items, managementProps));

          case Menu.MENU_CHILDREN.MENU_ITEM:
          default:
            return _react.default.createElement(_MenuItem.default, _extends({}, props, {
              onClick: onClickCallback,
              active: isActive,
              assignedKey: item.key
            }));
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          appearance = _this$props.appearance,
          className = _this$props.className,
          activeKeyPath = _this$props.activeKeyPath,
          items = _this$props.items,
          openKeyMap = _this$props.openKeyMap,
          onClick = _this$props.onClick,
          theme = _this$props.theme,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["appearance", "className", "activeKeyPath", "items", "openKeyMap", "onClick", "theme", "children"]);
      /* eslint-enable */


      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, this.props);
      var childrenWithProps = this.assignMenuManagement({
        children: children,
        activeKeyPath: activeKeyPath,
        openKeyMap: openKeyMap,
        onClickCallback: this.handleMenuChange
      }); // Convert items to React Elements

      var itemNodes;

      if (items) {
        itemNodes = this.renderItems(items, {
          activeKeyPath: activeKeyPath,
          openKeyMap: openKeyMap,
          onClickCallback: this.handleMenuChange
        });
      }

      return _react.default.createElement(_StackingLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-menu")),
        itemSpacing: "0px"
      }, styleProps, props), childrenWithProps, itemNodes);
    }
  }]);

  return Menu;
}(_react.default.Component);

exports.default = Menu;
Menu.APPEARANCE = {
  COMPACT: 'compact',
  DEFAULT: 'default'
};
Menu.MENU_CHILDREN = {
  DIVIDER: 'Divider',
  MENU_GROUP: 'MenuGroup',
  MENU_ITEM: 'MenuItem'
};
Menu.defaultProps = {
  appearance: 'default',
  theme: 'light'
};
Menu.propTypes = {
  /**
   * Appearance of the menu.
   */
  appearance: _propTypes.default.oneOf([Menu.APPEARANCE.COMPACT, Menu.APPEARANCE.DEFAULT]),

  /**
   * Provide additional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * Note: If both {props.items} and {props.children} is used the {children}
   * will render before the {items}.<br>
   * An array can consist of the any combination of following item shapes:<br>
   *
   * {<br>
   *   name: 'MenuItem',  : if {name} is not specified then 'MenuItem' will
   *                        return as the default.<br>
   *   children: <PropTypes.node>,<br>
   *   key: '1'<br>
   * }<br>
   * {<br>
   *   name: 'MenuGroup',<br>
   *   items: <Menu.PropTypes.items>,<br>
   *   key: '2'<br>
   * }<br>
   * {<br>
   *   name: 'Divider',<br>
   *   key: '3'<br>
   * }<br>
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    key: _propTypes.default.string.isRequired,
    children: _propTypes.default.array,
    items: _propTypes.default.array
  })),

  /**
   * Styling color theme.
   */
  theme: _propTypes.default.oneOf(['light', 'dark']),

  /**
   * Used to display selected menu item.
   *
   * Path of keys that is currently active. The last key being the selected menu item.
   */
  activeKeyPath: _propTypes.default.array,

  /**
   * Used to open collapsible MenuGroups.
   *
   * A multidimensional array of paths of keys that are currently open. The
   * last key in the array is the selected menu group.
   */
  openKeyMap: _propTypes.default.arrayOf(_propTypes.default.array),

  /**
   * Callback for onClick. Returns:<br>
   * `function({ event, key, keyPath, openKeyMap, item, type })`.
   *
   * Note: only MenuItem or MenuGroup will trigger the onClick event and that
   * they cannot be assigned their own onClick callbacks.<br>
   *
   * Shape details:
   *
   * event : DOM event,<br>
   * key : key of item,<br>
   * keyPath : keyPath to item,<br>
   * openKeyMap : Array of open keys,<br>
   * item : item (this),<br>
   * type : Item type e.g. 'collapsible-header'
   *
   */
  onClick: _propTypes.default.func,

  /**
   * The children can be MenuItem, MenuGroup, Divider, or any other
   * element preferred.
   */
  children: _propTypes.default.node
};